module.exports = __webpack_public_path__ + "assets/img/block-6ef718b2.png";